export default __webpack_public_path__ + "static/media/menu-close.ba2124e9.svg";